// import React from "react";
// import ReactDOM from "react-dom";
// import 'react-app-polyfill/stable';
// import 'react-app-polyfill/ie11';
// import "./index.css";
// import App from "./App";
// import * as serviceWorker from "./serviceWorker";
// import { BrowserRouter } from "react-router-dom";
// import { Provider } from 'react-redux'
// import store from './redux/store/store';
// import { PersistGate } from 'redux-persist/integration/react'
// import Loader from './utils/loader';
// import 'react-toastify/dist/ReactToastify.css';
// import VideoState from "./contexts/VideoState";
// ReactDOM.render(
//   <Provider store={store().store}>
//     <PersistGate loading={<Loader/>} persistor={store().persistor}>
//       <BrowserRouter>
//         <VideoState>
//         <App />
//         </VideoState>
//       </BrowserRouter>
//     </PersistGate>
//   </Provider>
//   ,
//   document.getElementById("root")
// );

// // If you want your app to work offline and load faster, you can change
// // unregister() to register() below. Note this comes with some pitfalls.
// // Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();


import React from "react";
import ReactDOM from "react-dom";
import "react-app-polyfill/stable";
import "react-app-polyfill/ie11";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import Loader from "./utils/loader";
import "react-toastify/dist/ReactToastify.css";
import VideoState from "./contexts/VideoState";
import { initAuthSession } from "./initAuthSession";
import { applyAppFont } from "./utils/appFont";
import { store, persistor } from "./redux/store/store";
// StylesProvider injectFirst ensures MUI v4 JSS styles are injected BEFORE
// MUI v5 Emotion styles in <head>, so v5 always wins specificity conflicts.
// Without this, JSS sometimes overrides Emotion on navigation, causing stale fonts/styles.
import { StylesProvider } from "@material-ui/core/styles";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import responsiveTheme from "./theme/responsiveTheme";

initAuthSession();

// Applied before the first render so the chosen typeface is already in
// place — no flash of the previous font on every page load.
applyAppFont();

// "ResizeObserver loop ..." is a benign browser notice (layout settled one
// frame late), but CRA's dev overlay reports it as a runtime error. Swallow
// only that message so real errors still surface.
const RESIZE_OBSERVER_ERROR =
  /ResizeObserver loop (limit exceeded|completed with undelivered notifications)/;
window.addEventListener("error", (event) => {
  if (RESIZE_OBSERVER_ERROR.test(event.message)) {
    event.stopImmediatePropagation();
    // If the dev-server overlay already rendered for this event, hide it.
    const overlay = document.getElementById(
      "webpack-dev-server-client-overlay"
    );
    const overlayDiv = document.getElementById(
      "webpack-dev-server-client-overlay-div"
    );
    if (overlay) overlay.style.display = "none";
    if (overlayDiv) overlayDiv.style.display = "none";
  }
});

// Every route in this app is a React.lazy() chunk. Each new build/deploy
// gives those chunks fresh content-hashed filenames — a tab left open (or
// restored) from before that happened still references the old filenames,
// so navigating into a not-yet-loaded route 404s with "Loading chunk X
// failed" instead of rendering the page. Recover automatically with a single
// reload (which fetches the current chunk map) rather than leaving the user
// on a dead error screen; the sessionStorage guard stops a reload loop if
// the failure isn't actually a stale-bundle mismatch.
const CHUNK_LOAD_ERROR = /Loading chunk .* failed|ChunkLoadError/;
function recoverFromChunkLoadError(message) {
  if (!CHUNK_LOAD_ERROR.test(message || "")) return;
  if (sessionStorage.getItem("chunkReloadAttempted")) return;
  sessionStorage.setItem("chunkReloadAttempted", "1");
  window.location.reload();
}

window.addEventListener("error", (event) => {
  recoverFromChunkLoadError(event.message || event.error?.message);
});
window.addEventListener("unhandledrejection", (event) => {
  recoverFromChunkLoadError(event.reason?.message || String(event.reason || ""));
});
// Once this load has run clean for a bit, allow a future distinct chunk
// failure (e.g. after a later deploy, hours into the same tab) to also
// trigger one auto-reload instead of being permanently silenced.
setTimeout(() => sessionStorage.removeItem("chunkReloadAttempted"), 10000);

ReactDOM.render(
  <StylesProvider injectFirst>
    <MuiThemeProvider theme={responsiveTheme}>
      <Provider store={store}>
        <PersistGate loading={<Loader />} persistor={persistor}>
          <BrowserRouter>
            <VideoState>
              <App />
            </VideoState>
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </MuiThemeProvider>
  </StylesProvider>,
  document.getElementById("root")
);

serviceWorker.unregister();
